import { Pipe, PipeTransform } from '@angular/core';

import { LocaleService } from '../services/locale.service';
import { UnitSystem, UnitConversionValue, FsSpeedOptions } from '../types/unit-system';
import { UnitConverter } from '../utils/unit-conversion';
import { UnitConversionBasePipe } from './unit-conversion-base.pipe';

const DEFAULT_SPEED_OPTIONS: Required<FsSpeedOptions> = {
  precision: 0,
  includeUnit: true,
  sourceUnit: 'imperial',
};

@Pipe({
  name: 'fsSpeed',
  pure: true,
})
export class FsSpeedPipe extends UnitConversionBasePipe implements PipeTransform {
  constructor(_localeService: LocaleService) {
    super(_localeService);
  }

  transform(value: UnitConversionValue, options?: FsSpeedOptions | number): string {
    const opts = typeof options === 'number' 
      ? { ...DEFAULT_SPEED_OPTIONS, precision: options }
      : { ...DEFAULT_SPEED_OPTIONS, ...options };
    
    return this.convertAndFormat(
      value,
      opts.precision,
      opts.includeUnit,
      opts.sourceUnit,
      UnitConverter.convertMilesToKilometers,
      (system) => this._localeService.getUnitConfig().speed.symbol
    );
  }
}

